import { Component, Inject, Input, OnDestroy, OnInit, ViewChild, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { BaseComponent } from '../../base/base.component';
import { Task } from 'app/shared/models/task';
import { User } from 'app/shared/models/user';
import { UserService } from 'app/shared/services/user.service';
import { FuseTaskDetailsComponent } from '../task-details/task-details.component';

@Component({
  selector: 'app-task-dialog',
  templateUrl: './task-dialog.component.html',
  styleUrls: ['./task-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class TaskDialogComponent extends BaseComponent implements OnInit, OnDestroy {
  public userList: User[] = [];
  inWidget = false;
  showLink = false;
  readOnly = false;

  @ViewChild('details') details: FuseTaskDetailsComponent;

  task: Task = null;

  constructor(public dialogRef: MatDialogRef<TaskDialogComponent>,
              @Inject(MAT_DIALOG_DATA) public data: TaskDialogData,
              private userService: UserService,
  ) {
    super();

    this.task = data.task;
    this.inWidget = data.inWidget;
    this.showLink = data.showLink;
    this.readOnly = data.readOnly;

    if (this.task.id === undefined || this.task.id < 1) {
      this.task.uid = null;
      this.task.summary = '';
      this.task.taskStatus = 10;
      this.task.taskStatusName = 'Open';
      this.task.dateCreated = new Date(Date.now());
      this.task.createdById = this.userService.getCurrentUserId();
      this.task.createdBy = this.userList.find((u) => u.id === this.task.createdById);
      this.task.starred = false;
      this.task.important = false;
    }
    this.task.actionFor = this.userList.find((u) => u.id === this.task.actionForId);
    this.readOnly = this.readOnly || (this.task.subject && this.task.subject.archived);
  }

  ngOnInit() {
  }

  ngOnDestroy() {
  }

  toggleStar(event) {
    this.details.toggleStar(event);
  }

  toggleImportant(event) {
    this.details.toggleImportant(event);
  }

  closeDialog() {
    this.details.canClose().subscribe((result: boolean) => {
      if (result) {
        this.dialogRef.close();
      }
    });
  }
}

// tslint:disable-next-line:max-classes-per-file
export class TaskDialogData {
  task: Task;
  inWidget: boolean;
  showLink: boolean;
  readOnly: boolean;

  constructor(task: Task, readOnly?: boolean, inWidget?: boolean, showLink?: boolean) {
    this.task = task;
    this.readOnly = readOnly || false;
    this.inWidget = inWidget || false;
    this.showLink = showLink || false;
  }
}
